
import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("TarifaPagoChofer");
const crud = rpcCrudService<models.TarifaPagoChofer, models.TarifaPagoChofer>(controller);


export const TarifaPagoChofer = cacheResource({
    ...crud,
}, {
    query: true,
    getMemo: true,
}, {
    add: true,
    delete: true,
    update: true
});



// WEBPACK FOOTER //
// ./app/resources/items/tarifapagochofer.tsx